export const stripHtmlTags = (str: string) => {
  if (str) {
    return str.replace(/<br \/>/g, '\n').replace(/<[^>]*>?/gm, '');
  }
  return '';
};
